<template>
  <span>
    <router-link v-bind:id="id" v-bind:to="href"
                 v-bind:class="link_class"
                 v-on:mouseover.native="get_balance"
                 v-bind:style="link_style">{{text}}</router-link>
    <b-popover v-bind:target="id" triggers="hover" placement="top">
      <b-row>
        <b-col>
            <b>XRP</b> : {{balance | delim}}
        </b-col>
      </b-row>

      <b-row>
         <b-col v-if="have_trust_lines" >
          <b>Top trustlines</b>
          <table>
            <tr v-for="tl in trust_lines" v-bind:key="tl.currency">
              <td style="color: #283faa">{{tl.currency}}:</td>
              <td>{{tl.value}}</td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-popover>
  </span>
</template>

<script>
var CommandDispatcher = require('../mixins/command_dispatcher')
import tags from '../tags'
import config from '../config'

function get_balance(vue){
  var cmd = {
    command : 'account_info',
    account : vue.account
  };

  vue.sendCmd(cmd, function(account){
    var drops = account["account_data"]["Balance"];
    vue.balance = parseFloat((drops / config.DROPS_PER_XRP).toFixed(3));
  });
}

function get_trust_lines(vue){
  var url = config.DATA_URI + "/account/" + vue.account + "/trust_lines";
  vue.$http.get(url)
           .then(function(response){
             if(Object.keys(response['body']).length == 0) return;
 
             vue.trust_lines = [];
             var trust_lines = response['body']
             Object.keys(trust_lines).forEach(function(k){
               vue.trust_lines.push({currency : k,
                                     value    : trust_lines[k]});
             })

             vue.trust_lines.sort(function(a,b){
               return b.value-a.value
             });

             vue.trust_lines = vue.trust_lines.splice(0, 10);
           });
}

export default {
  name: 'AccountLink',

  mixins : [CommandDispatcher],

  props : {
    account : String,
    link_style : String,
    link_class : String,
    shorten : Boolean,
    no_tag : Boolean
  },

  data : function(){
    return { balance : 0,
             trust_lines : []};
  },

  computed : {
    id : function(){
      return "account_link_" + this.account + Math.random();
    },

    href : function(){
      return "/account/" + this.account;
    },

    text : function(){
      var t = tags.non_special_tags_for(this.account);
      if(this.no_tag || t.length == 0){
        if(this.shorten)
          return this.account.substr(0, 7) + "...";
        return this.account;
      }
      return t[0];
    },

    have_trust_lines : function(){
      return this.trust_lines.length != 0;
    }
  },

  methods : {
    get_balance : function(){
      get_balance(this);
      get_trust_lines(this);
    }
  },
}
</script>

<style scoped>
.account_link {
  font-size: 0.9rem;
}
</style>
